/* Wild Beauty — Animation Engine */
(function(){
  'use strict';

  // ── Scroll Reveal ──
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting)return;
      e.target.classList.add('wb-in');
      io.unobserve(e.target);
    });
  },{threshold:0.1,rootMargin:'0px 0px -40px 0px'});
  document.querySelectorAll('.wb-reveal,.wb-reveal-left,.wb-reveal-right').forEach(function(el){io.observe(el);});
  document.querySelectorAll('.wb-reveal-stagger').forEach(function(c){
    c.querySelectorAll(':scope > *').forEach(function(ch){io.observe(ch);});
  });

  // ── Hero Particles ──
  var canvas=document.querySelector('.wb-particles');
  if(canvas){
    var ctx=canvas.getContext('2d');
    function resize(){canvas.width=canvas.offsetWidth;canvas.height=canvas.offsetHeight;}
    resize();
    window.addEventListener('resize',resize,{passive:true});
    var pts=[];
    for(var i=0;i<60;i++){pts.push({x:Math.random()*canvas.width,y:Math.random()*canvas.height,r:Math.random()*1.3+0.3,vx:(Math.random()-.5)*.22,vy:-(Math.random()*.3+.04),o:Math.random()*.45+.08});}
    function draw(){
      ctx.clearRect(0,0,canvas.width,canvas.height);
      pts.forEach(function(p){
        ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
        ctx.fillStyle='rgba(224,168,50,'+p.o+')';ctx.fill();
        p.x+=p.vx;p.y+=p.vy;
        if(p.y<-5){p.y=canvas.height+5;p.x=Math.random()*canvas.width;}
        if(p.x<-5)p.x=canvas.width+5;
        if(p.x>canvas.width+5)p.x=-5;
      });
      requestAnimationFrame(draw);
    }
    draw();
  }

  // ── Magnetic Buttons ──
  document.querySelectorAll('.wb-btn-primary,.wb-btn-outline').forEach(function(btn){
    btn.addEventListener('mousemove',function(e){
      var r=btn.getBoundingClientRect();
      var x=(e.clientX-r.left-r.width/2)*.16;
      var y=(e.clientY-r.top-r.height/2)*.16;
      btn.style.transform='translate('+x+'px,'+y+'px)';
    });
    btn.addEventListener('mouseleave',function(){btn.style.transform='';});
  });

  // ── 3D Card Tilt ──
  document.querySelectorAll('.wb-product-card,.wb-book-card').forEach(function(card){
    card.addEventListener('mousemove',function(e){
      var r=card.getBoundingClientRect();
      var x=((e.clientX-r.left)/r.width-.5)*9;
      var y=((e.clientY-r.top)/r.height-.5)*9;
      card.style.transform='perspective(900px) rotateX('+(-y)+'deg) rotateY('+x+'deg) translateY(-5px)';
      card.style.boxShadow='0 20px 48px rgba(4,37,53,.18)';
    });
    card.addEventListener('mouseleave',function(){card.style.transform='';card.style.boxShadow='';});
  });

  // ── Category Card Tilt ──
  document.querySelectorAll('.wb-cat-card').forEach(function(card){
    card.addEventListener('mousemove',function(e){
      var r=card.getBoundingClientRect();
      var x=((e.clientX-r.left)/r.width-.5)*7;
      var y=((e.clientY-r.top)/r.height-.5)*7;
      card.style.transform='perspective(900px) rotateX('+(-y)+'deg) rotateY('+x+'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave',function(){card.style.transform='';});
  });

  // ── Hero Parallax ──
  var hero=document.querySelector('.wb-hero');
  if(hero){
    window.addEventListener('scroll',function(){
      var s=window.scrollY;
      if(s<hero.offsetHeight*1.3)hero.style.backgroundPositionY='calc(50% + '+(s*.18)+'px)';
    },{passive:true});
  }

  // ── Ripple on Click ──
  document.querySelectorAll('.wb-btn-primary,.wb-view-book,.wb-add-to-cart').forEach(function(btn){
    btn.addEventListener('click',function(e){
      var r=this.getBoundingClientRect();
      var size=Math.max(r.width,r.height);
      var rip=document.createElement('span');
      rip.className='wb-ripple';
      rip.style.cssText='width:'+size+'px;height:'+size+'px;left:'+(e.clientX-r.left-size/2)+'px;top:'+(e.clientY-r.top-size/2)+'px';
      this.appendChild(rip);
      setTimeout(function(){rip.remove();},650);
    });
  });

})();
